module.exports = __webpack_public_path__ + "img/bombillo_2.a391f2d4.svg";